module.exports = __webpack_public_path__ + "static/img/6.4abab0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/6.png
// module id = KNaC
// module chunks = 0